<div class="background-color"></div>
<div class="background-template"></div>
<div class="center-content">
<div class="center-div">
  <form [formGroup]="resetPasswordForm" >
      <ng-container *ngIf="isSetMsgType ; else resetPassword">
        <div class="title-content">Initialisation du mot de passe pour le compte {{email}}</div>
      </ng-container>
      <ng-template #resetPassword>
        <div class="title-content">Changement de mot de passe pour le compte {{email}}</div>
      </ng-template>          
      <div class="loginSaisieChamps">
        <div class="inputChmp">
          <mat-form-field class="form-group ">
            <input matInput placeholder="Nouveau mot de passe" required [type]="hide2 ? 'password' : 'text'" required
              formControlName="passwordNew">
            <mat-error>
              Requis : 1 maj, 1 min, 1 nombre, longueur 8+
            </mat-error>
            <mat-icon matSuffix (click)="hide2 = !hide2">{{hide2 ? 'visibility' : 'visibility_off'}}
            </mat-icon>
          </mat-form-field>
        </div>
        <div class="inputChmp">
          <mat-form-field class="form-group ">
            <input matInput placeholder="Confirmer le mot de passe" [type]="hide3 ? 'password' : 'text'" required
              formControlName="newPasswordConfirm">
            <mat-error>
              confirmation requise
            </mat-error>
            <mat-icon matSuffix (click)="hide3 = !hide3">{{hide3 ? 'visibility' : 'visibility_off'}}
            </mat-icon>
          </mat-form-field>
        </div>
        <div class="inputChmp" style="display:none">
          <mat-form-field class="form-group ">
            <input matInput placeholder="Confirmer le mot de passe"
              [value]="email"
              formControlName="newPasswordConfirm">
          </mat-form-field>
        </div>        
      </div>
      <div style="margin-top: 10px;">
        <span>
          <button matButton="filled" class="secondary" (click)="onSubmit()"
            [disabled]="!resetPasswordForm.valid || postWainting">Envoyer<ng-container
              *ngIf="postWainting">...</ng-container></button>
        </span>
        <span style="float: right;">
          <button routerLink="/login" matButton>Retour</button>
        </span>
      </div>
  </form>
</div>